export default "__VITE_ASSET__$3ZJwt7H__"